module.exports = __webpack_public_path__ + "img/btn_slide_next.a087a988.svg";